import { render, staticRenderFns } from "./Administratori.vue?vue&type=template&id=25b50c89&scoped=true&"
import script from "./Administratori.vue?vue&type=script&lang=js&"
export * from "./Administratori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b50c89",
  null
  
)

export default component.exports